import { Moment } from "moment";
import { MetadataType } from "./documentMetadata";
import { Rect } from "../helpers/geometry.helper";
import { DocumentRedactInfo } from "./documentRedactInfo";

export interface DocumentEvidence {
  _id?: string;
  type: MetadataType;
  metadata: string;
  document: string;
  page: number;
  start?: number[];
  end?: number[];
  manual: boolean;
  user?: {
    ref: string;
    firstName: string;
    lastName: string;
    avatar: string;
  };
  createdAt?: Moment;
  // Set by the frontend when viewing a document through a case context to
  // flag evidence that exists on the document but is outside the case scope
  // (kept visible but read-only).
  excluded?: boolean;
}

export enum HighlightRectType {
  EVIDENCE = 'EVIDENCE',
  REDACT = 'REDACT'
}

export type HighlightRect<T extends DocumentEvidence | DocumentRedactInfo = DocumentEvidence | DocumentRedactInfo> = Rect & {
  value: T,
  type: HighlightRectType
}